/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
// AUTO-GENERATED by scripts/generateUnitsJson.ts. Do not edit by hand.

/** @internal */
export const basicUnitConversionData = {
  "Units.A": ["Units.CURRENT", 1, 0],
  "Units.ACRE": ["Units.AREA", 0.000247105381467165, 0],
  "Units.ACRE_FT": ["Units.VOLUME", 0.000810713193789913, 0],
  "Units.ACRE_FT_PER_DAY": ["Units.VOLUMETRIC_FLOW", 70.0456199434485, 0],
  "Units.ACRE_FT_PER_HR": ["Units.VOLUMETRIC_FLOW", 2.91856749764369, 0],
  "Units.ACRE_FT_PER_MIN": ["Units.VOLUMETRIC_FLOW", 0.0486427916273948, 0],
  "Units.ACRE_IN": ["Units.VOLUME", 0.00972855832547895, 0],
  "Units.ACRE_IN_PER_DAY": ["Units.VOLUMETRIC_FLOW", 840.547439321381, 0],
  "Units.ACRE_IN_PER_HR": ["Units.VOLUMETRIC_FLOW", 35.0228099717242, 0],
  "Units.ACRE_IN_PER_MIN": ["Units.VOLUMETRIC_FLOW", 0.583713499528737, 0],
  "Units.ARC_DEG": ["Units.ANGLE", 57.2957795130823, 0],
  "Units.ARC_MINUTE": ["Units.ANGLE", 3437.74677078494, 0],
  "Units.ARC_QUADRANT": ["Units.ANGLE", 0.636619772367581, 0],
  "Units.ARC_SECOND": ["Units.ANGLE", 206264.806247096, 0],
  "Units.ARE": ["Units.AREA", 0.01, 0],
  "Units.AREA_SPRING_CONSTANT_KN_PER_CUB_M": ["Units.AREA_SPRING_CONSTANT", 0.001, 0],
  "Units.AREA_SPRING_CONSTANT_KPF_PER_CUB_FT": ["Units.AREA_SPRING_CONSTANT", 0.00000636588035426416, 0],
  "Units.AREA_SPRING_CONSTANT_N_PER_CUB_M": ["Units.AREA_SPRING_CONSTANT", 1, 0],
  "Units.AT": ["Units.PRESSURE", 0.0000101971621297793, 0],
  "Units.AT_GAUGE": ["Units.PRESSURE", 0.0000101971621297793, -1.03322745279989],
  "Units.ATM": ["Units.PRESSURE", 0.00000986923266716013, 0],
  "Units.BAR": ["Units.PRESSURE", 0.00001, 0],
  "Units.BAR_GAUGE": ["Units.PRESSURE", 0.00001, -1.01325],
  "Units.BAR_PER_KM": ["Units.PRESSURE_GRADIENT", 0.01, 0],
  "Units.BARYE": ["Units.PRESSURE", 10, 0],
  "Units.BTU": ["Units.WORK", 0.000947817120313317, 0],
  "Units.BTU_IN_PER_SQ_FT_HR_FAHRENHEIT": ["Units.THERMAL_CONDUCTIVITY", 6.93347179851598, 0],
  "Units.BTU_PER_FAHRENHEIT": ["Units.ENTROPY", 0.000526565066840732, 0],
  "Units.BTU_PER_HR": ["Units.POWER", 3.41214163312794, 0],
  "Units.BTU_PER_LB_MOL_RANKINE": ["Units.SPECIFIC_HEAT_CAPACITY_MOLAR", 0.238845896627496, 0],
  "Units.BTU_PER_LBM": ["Units.SPECIFIC_ENERGY", 0.000429922613929493, 0],
  "Units.BTU_PER_LBM_RANKINE": ["Units.SPECIFIC_HEAT_CAPACITY", 0.000238845896627496, 0],
  "Units.BTU_PER_SQ_FT_HR_FAHRENHEIT": ["Units.HEAT_TRANSFER", 0.176110183682306, 0],
  "Units.CD": ["Units.LUMINOSITY", 1, 0],
  "Units.CELSIUS": ["Units.TEMPERATURE", 1, -273.15],
  "Units.CENTIPOISE": ["Units.DYNAMIC_VISCOSITY", 1000, 0],
  "Units.CENTISTOKE": ["Units.KINEMATIC_VISCOSITY", 1000000, 0],
  "Units.CHAIN": ["Units.LENGTH", 0.0497096953789867, 0],
  "Units.CM": ["Units.LENGTH", 100, 0],
  "Units.CM_PER_DAY": ["Units.VELOCITY", 8640000, 0],
  "Units.CM_PER_HR": ["Units.VELOCITY", 360000, 0],
  "Units.CM_PER_M": ["Units.SLOPE", 100, 0],
  "Units.CM_PER_MIN": ["Units.VELOCITY", 6000, 0],
  "Units.CM_PER_SEC": ["Units.VELOCITY", 100, 0],
  "Units.CM_PER_SEC_SQ": ["Units.ACCELERATION", 100, 0],
  "Units.CM_TO_THE_FOURTH": ["Units.AREA_MOMENT_INERTIA", 100000000, 0],
  "Units.CM_TO_THE_SIXTH": ["Units.TORSIONAL_WARPING_CONSTANT", 1000000000000, 0],
  "Units.COEFFICIENT": ["Units.NUMBER", 1, 0],
  "Units.COULOMB": ["Units.ELECTRIC_CHARGE", 1, 0],
  "Units.CUB_CM": ["Units.VOLUME", 1000000, 0],
  "Units.CUB_DM": ["Units.VOLUME", 1000, 0],
  "Units.CUB_FT": ["Units.VOLUME", 35.3146667214886, 0],
  "Units.CUB_FT_PER_ACRE_SEC": ["Units.FLOW_DENSITY_PER_AREA", 142913.385826772, 0],
  "Units.CUB_FT_PER_DAY": ["Units.VOLUMETRIC_FLOW", 3051187.20473661, 0],
  "Units.CUB_FT_PER_FT": ["Units.VOLUME_PER_LENGTH", 10.7639104167097, 0],
  "Units.CUB_FT_PER_LB_MOL": ["Units.MOLAR_VOLUME", 16018.4633739601, 0],
  "Units.CUB_FT_PER_LBM": ["Units.SPECIFIC_VOLUME", 16.0184633739601, 0],
  "Units.CUB_FT_PER_MIN": ["Units.VOLUMETRIC_FLOW", 2118.88000328932, 0],
  "Units.CUB_FT_PER_SEC": ["Units.VOLUMETRIC_FLOW", 35.3146667214886, 0],
  "Units.CUB_FT_PER_SQ_FT_MIN": ["Units.FLOW_DENSITY_PER_AREA", 196.850393700787, 0],
  "Units.CUB_FT_PER_SQ_FT_SEC": ["Units.FLOW_DENSITY_PER_AREA", 3.28083989501312, 0],
  "Units.CUB_FT_PER_SQ_MILE_SEC": ["Units.FLOW_DENSITY_PER_AREA", 91464566.9291339, 0],
  "Units.CUB_IN": ["Units.VOLUME", 61023.7440947323, 0],
  "Units.CUB_IN_PER_MIN": ["Units.VOLUMETRIC_FLOW", 3661424.64568394, 0],
  "Units.CUB_IN_PER_SEC": ["Units.VOLUMETRIC_FLOW", 61023.7440947323, 0],
  "Units.CUB_KM": ["Units.VOLUME", 1e-9, 0],
  "Units.CUB_M": ["Units.VOLUME", 1, 0],
  "Units.CUB_M_PER_CUB_M": ["Units.VOLUME_RATIO", 1, 0],
  "Units.CUB_M_PER_DAY": ["Units.VOLUMETRIC_FLOW", 86400, 0],
  "Units.CUB_M_PER_HECTARE_DAY": ["Units.FLOW_DENSITY_PER_AREA", 864000000, 0],
  "Units.CUB_M_PER_HR": ["Units.VOLUMETRIC_FLOW", 3600, 0],
  "Units.CUB_M_PER_KG": ["Units.SPECIFIC_VOLUME", 1, 0],
  "Units.CUB_M_PER_KMOL": ["Units.MOLAR_VOLUME", 1000, 0],
  "Units.CUB_M_PER_M": ["Units.VOLUME_PER_LENGTH", 1, 0],
  "Units.CUB_M_PER_MIN": ["Units.VOLUMETRIC_FLOW", 60, 0],
  "Units.CUB_M_PER_MOL": ["Units.MOLAR_VOLUME", 1, 0],
  "Units.CUB_M_PER_SEC": ["Units.VOLUMETRIC_FLOW", 1, 0],
  "Units.CUB_M_PER_SQ_KM_DAY": ["Units.FLOW_DENSITY_PER_AREA", 86400000000, 0],
  "Units.CUB_M_PER_SQ_M_DAY": ["Units.FLOW_DENSITY_PER_AREA", 86400, 0],
  "Units.CUB_M_PER_SQ_M_SEC": ["Units.FLOW_DENSITY_PER_AREA", 1, 0],
  "Units.CUB_MILE": ["Units.VOLUME", 2.39912758578928e-10, 0],
  "Units.CUB_MM": ["Units.VOLUME", 1000000000, 0],
  "Units.CUB_UM": ["Units.VOLUME", 1000000000000000000, 0],
  "Units.CUB_US_SURVEY_FT": ["Units.VOLUME", 35.314454833912, 0],
  "Units.CUB_US_SURVEY_IN": ["Units.VOLUME", 61023.377953, 0],
  "Units.CUB_US_SURVEY_MILE": ["Units.VOLUME", 2.39911319105255e-10, 0],
  "Units.CUB_US_SURVEY_YRD": ["Units.VOLUME", 1.30794277162637, 0],
  "Units.CUB_YRD": ["Units.VOLUME", 1.30795061931439, 0],
  "Units.DAY": ["Units.TIME", 0.0000115740740740741, 0],
  "Units.DECAN": ["Units.FORCE", 0.1, 0],
  "Units.DECIMAL_PERCENT": ["Units.PERCENTAGE", 0.01, 0],
  "Units.DEG_PER_HR": ["Units.ANGULAR_VELOCITY", 206264.806247096, 0],
  "Units.DEG_PER_MIN": ["Units.ANGULAR_VELOCITY", 3437.74677078494, 0],
  "Units.DEG_PER_SEC": ["Units.ANGULAR_VELOCITY", 57.2957795130823, 0],
  "Units.DELTA_CELSIUS": ["Units.TEMPERATURE_CHANGE", 1, 0],
  "Units.DELTA_FAHRENHEIT": ["Units.TEMPERATURE_CHANGE", 1.8, 0],
  "Units.DELTA_KELVIN": ["Units.TEMPERATURE_CHANGE", 1, 0],
  "Units.DELTA_RANKINE": ["Units.TEMPERATURE_CHANGE", 1.8, 0],
  "Units.DM": ["Units.LENGTH", 10, 0],
  "Units.DYNE": ["Units.FORCE", 100000, 0],
  "Units.FAHRENHEIT": ["Units.TEMPERATURE", 1.8, -459.67],
  "Units.FT": ["Units.LENGTH", 3.28083989501312, 0],
  "Units.FT_FT": ["Units.PIPE_DIAMETER_LENGTH", 10.7639104167097, 0],
  "Units.FT_H2O": ["Units.PRESSURE", 0.000334552554358935, 0],
  "Units.FT_HORIZONTAL_PER_FT_VERTICAL": ["Units.SLOPE", 1, 0, "Units.FT_PER_FT"],
  "Units.FT_MILE": ["Units.PIPE_DIAMETER_LENGTH", 0.00203861939710411, 0],
  "Units.FT_PDL": ["Units.WORK", 23.7303604042319, 0],
  "Units.FT_PER_DAY": ["Units.VELOCITY", 283464.566929134, 0],
  "Units.FT_PER_FT": ["Units.SLOPE", 1, 0],
  "Units.FT_PER_HR": ["Units.VELOCITY", 11811.0236220472, 0],
  "Units.FT_PER_IN": ["Units.SLOPE", 0.0833333333333333, 0],
  "Units.FT_PER_MILE": ["Units.SLOPE", 5280, 0],
  "Units.FT_PER_MIN": ["Units.VELOCITY", 196.850393700787, 0],
  "Units.FT_PER_SEC": ["Units.VELOCITY", 3.28083989501312, 0],
  "Units.FT_PER_SEC_SQ": ["Units.ACCELERATION", 3.28083989501312, 0],
  "Units.FT_PER_THOUSAND_FOOT": ["Units.SLOPE", 1000, 0],
  "Units.FT_TO_THE_FOURTH": ["Units.AREA_MOMENT_INERTIA", 115.861767458952, 0],
  "Units.FT_TO_THE_SIXTH": ["Units.TORSIONAL_WARPING_CONSTANT", 1247.12568564981, 0],
  "Units.G": ["Units.MASS", 1000, 0],
  "Units.G_PER_CUB_CM": ["Units.DENSITY", 0.001, 0],
  "Units.G_PER_HR": ["Units.MASS_FLOW", 3600000, 0],
  "Units.G_PER_MIN": ["Units.MASS_FLOW", 60000, 0],
  "Units.G_PER_SEC": ["Units.MASS_FLOW", 1000, 0],
  "Units.G_PER_SQ_M": ["Units.SURFACE_DENSITY", 1000, 0],
  "Units.GALLON": ["Units.VOLUME", 264.172052358148, 0],
  "Units.GALLON_IMPERIAL": ["Units.VOLUME", 219.969248299088, 0],
  "Units.GALLON_IMPERIAL_PER_DAY": ["Units.VOLUMETRIC_FLOW", 19005343.0530412, 0],
  "Units.GALLON_IMPERIAL_PER_HR": ["Units.VOLUMETRIC_FLOW", 791889.293876716, 0],
  "Units.GALLON_IMPERIAL_PER_MIN": ["Units.VOLUMETRIC_FLOW", 13198.1548979453, 0],
  "Units.GALLON_IMPERIAL_PER_SEC": ["Units.VOLUMETRIC_FLOW", 219.969248299088, 0],
  "Units.GALLON_PER_ACRE_DAY": ["Units.FLOW_DENSITY_PER_AREA", 92367334083.2396, 0],
  "Units.GALLON_PER_ACRE_MIN": ["Units.FLOW_DENSITY_PER_AREA", 64143982.0022497, 0],
  "Units.GALLON_PER_DAY": ["Units.VOLUMETRIC_FLOW", 22824465.323744, 0],
  "Units.GALLON_PER_HR": ["Units.VOLUMETRIC_FLOW", 951019.388489334, 0],
  "Units.GALLON_PER_MIN": ["Units.VOLUMETRIC_FLOW", 15850.3231414889, 0],
  "Units.GALLON_PER_SEC": ["Units.VOLUMETRIC_FLOW", 264.172052358148, 0],
  "Units.GALLON_PER_SQ_FT_DAY": ["Units.FLOW_DENSITY_PER_AREA", 2120462.2149504, 0],
  "Units.GALLON_PER_SQ_FT_MIN": ["Units.FLOW_DENSITY_PER_AREA", 1472.54320482667, 0],
  "Units.GALLON_PER_SQ_MILE_DAY": ["Units.FLOW_DENSITY_PER_AREA", 59115093813273.4, 0],
  "Units.GALLON_PER_SQ_MILE_MIN": ["Units.FLOW_DENSITY_PER_AREA", 41052148481.4398, 0],
  "Units.GJ": ["Units.WORK", 1e-9, 0],
  "Units.GRAD": ["Units.ANGLE", 63.6619772367581, 0],
  "Units.GRM": ["Units.MASS", 15432.3583529414, 0],
  "Units.GRM_PER_LBM": ["Units.MASS_RATIO", 7000, 0],
  "Units.GW": ["Units.POWER", 1e-9, 0],
  "Units.GWH": ["Units.WORK", 2.77777777777778e-13, 0],
  "Units.HECTARE": ["Units.AREA", 0.0001, 0],
  "Units.HECTOPASCAL": ["Units.PRESSURE", 0.01, 0],
  "Units.HORIZONTAL_DIR_ARC_DEG": ["Units.HORIZONTAL_DIRECTION", 57.2957795130823, 0],
  "Units.HORIZONTAL_DIR_ARC_MINUTE": ["Units.HORIZONTAL_DIRECTION", 3437.74677078494, 0],
  "Units.HORIZONTAL_DIR_ARC_SECOND": ["Units.HORIZONTAL_DIRECTION", 206264.806247096, 0],
  "Units.HORIZONTAL_DIR_GRAD": ["Units.HORIZONTAL_DIRECTION", 63.6619772367581, 0],
  "Units.HORIZONTAL_DIR_MILLIRAD": ["Units.HORIZONTAL_DIRECTION", 318.309886183791, 0],
  "Units.HORIZONTAL_DIR_RAD": ["Units.HORIZONTAL_DIRECTION", 1, 0],
  "Units.HORIZONTAL_DIR_REVOLUTION": ["Units.HORIZONTAL_DIRECTION", 0.159154943091895, 0],
  "Units.HORIZONTAL_PER_VERTICAL": ["Units.SLOPE", 1, 0, "Units.VERTICAL_PER_HORIZONTAL"],
  "Units.HP": ["Units.POWER", 0.00134102208959503, 0],
  "Units.HR": ["Units.TIME", 0.000277777777777778, 0],
  "Units.HUNDRED_PERSON": ["Units.CAPITA", 0.01, 0],
  "Units.HZ": ["Units.FREQUENCY", 1, 0],
  "Units.IN": ["Units.LENGTH", 39.3700787401575, 0],
  "Units.IN_FT": ["Units.PIPE_DIAMETER_LENGTH", 129.166925000517, 0],
  "Units.IN_H2O_AT_32F": ["Units.PRESSURE", 0.00401431827040689, 0],
  "Units.IN_H2O_AT_39_2F": ["Units.PRESSURE", 0.00401474213311279, 0],
  "Units.IN_H2O_AT_60F": ["Units.PRESSURE", 0.00401864651985211, 0],
  "Units.IN_HG": ["Units.PRESSURE", 0.000295299801647123, 0],
  "Units.IN_HG_AT_32F": ["Units.PRESSURE", 0.000295300586466965, 0],
  "Units.IN_HG_AT_60F": ["Units.PRESSURE", 0.000296133971008484, 0],
  "Units.IN_M": ["Units.PIPE_DIAMETER_LENGTH", 39.3700787401575, 0],
  "Units.IN_MILE": ["Units.PIPE_DIAMETER_LENGTH", 0.0244634327652494, 0],
  "Units.IN_PER_DAY": ["Units.VELOCITY", 3401574.80314961, 0],
  "Units.IN_PER_DEGREE": ["Units.THREAD_PITCH", 0.687137500785169, 0],
  "Units.IN_PER_FT": ["Units.SLOPE", 12, 0],
  "Units.IN_PER_HR": ["Units.VELOCITY", 141732.283464567, 0],
  "Units.IN_PER_MIN": ["Units.VELOCITY", 2362.20472440945, 0],
  "Units.IN_PER_SEC": ["Units.VELOCITY", 39.3700787401575, 0],
  "Units.IN_TO_THE_FOURTH": ["Units.AREA_MOMENT_INERTIA", 2402509.61002883, 0],
  "Units.IN_TO_THE_SIXTH": ["Units.TORSIONAL_WARPING_CONSTANT", 3723897343.33937, 0],
  "Units.INVERSE_KN": ["Units.MOMENT_DISPLAY_SCALE", 1000, 0],
  "Units.INVERSE_KPF": ["Units.MOMENT_DISPLAY_SCALE", 4448.2216152605, 0],
  "Units.INVERSE_N": ["Units.MOMENT_DISPLAY_SCALE", 1, 0],
  "Units.J": ["Units.WORK", 1, 0],
  "Units.J_PER_CUB_M": ["Units.ENERGY_DENSITY", 1, 0],
  "Units.J_PER_G_CELSIUS": ["Units.SPECIFIC_HEAT_CAPACITY", 0.001, 0],
  "Units.J_PER_K": ["Units.ENTROPY", 1, 0],
  "Units.J_PER_KG": ["Units.SPECIFIC_ENERGY", 1, 0],
  "Units.J_PER_KG_K": ["Units.SPECIFIC_HEAT_CAPACITY", 1, 0],
  "Units.J_PER_KMOL_K": ["Units.SPECIFIC_HEAT_CAPACITY_MOLAR", 1000, 0],
  "Units.J_PER_MOL_K": ["Units.SPECIFIC_HEAT_CAPACITY_MOLAR", 1, 0],
  "Units.K": ["Units.TEMPERATURE", 1, 0],
  "Units.KELVIN_PER_M": ["Units.TEMPERATURE_GRADIENT", 1, 0],
  "Units.KG": ["Units.MASS", 1, 0],
  "Units.KG_PER_CUB_CM": ["Units.DENSITY", 0.000001, 0],
  "Units.KG_PER_CUB_M": ["Units.DENSITY", 1, 0],
  "Units.KG_PER_DAY": ["Units.MASS_FLOW", 86400, 0],
  "Units.KG_PER_HECTARE": ["Units.SURFACE_DENSITY", 10000, 0],
  "Units.KG_PER_HR": ["Units.MASS_FLOW", 3600, 0],
  "Units.KG_PER_KG": ["Units.MASS_RATIO", 1, 0],
  "Units.KG_PER_LITRE": ["Units.DENSITY", 0.001, 0],
  "Units.KG_PER_M": ["Units.LINEAR_DENSITY", 1, 0],
  "Units.KG_PER_MIN": ["Units.MASS_FLOW", 60, 0],
  "Units.KG_PER_MM": ["Units.LINEAR_DENSITY", 0.001, 0],
  "Units.KG_PER_SEC": ["Units.MASS_FLOW", 1, 0],
  "Units.KG_PER_SQ_M": ["Units.SURFACE_DENSITY", 1, 0],
  "Units.KGF": ["Units.FORCE", 0.101971621297793, 0],
  "Units.KGF_M": ["Units.TORQUE", 0.101971621297793, 0],
  "Units.KGF_PER_M": ["Units.LINEAR_LOAD", 0.101971621297793, 0],
  "Units.KGF_PER_SQ_M": ["Units.PRESSURE", 0.101971621297793, 0],
  "Units.KHZ": ["Units.FREQUENCY", 0.001, 0],
  "Units.KILOAMPERE": ["Units.CURRENT", 0.001, 0],
  "Units.KILOBTU": ["Units.WORK", 9.47817120313317e-7, 0],
  "Units.KILOBTU_PER_HR": ["Units.POWER", 0.00341214163312794, 0],
  "Units.KILOPASCAL": ["Units.PRESSURE", 0.001, 0],
  "Units.KILOPASCAL_GAUGE": ["Units.PRESSURE", 0.001, -101.325],
  "Units.KILOVOLT": ["Units.ELECTRIC_POTENTIAL", 0.001, 0],
  "Units.KIP_PER_CUB_FT": ["Units.DENSITY", 0.0000624279605761446, 0],
  "Units.KIPM": ["Units.MASS", 0.00220462262184878, 0],
  "Units.KJ": ["Units.WORK", 0.001, 0],
  "Units.KJ_PER_CUB_M": ["Units.ENERGY_DENSITY", 0.001, 0],
  "Units.KJ_PER_K": ["Units.ENTROPY", 0.001, 0],
  "Units.KJ_PER_KG": ["Units.SPECIFIC_ENERGY", 0.001, 0],
  "Units.KJ_PER_KMOL_K": ["Units.SPECIFIC_HEAT_CAPACITY_MOLAR", 1, 0],
  "Units.KM": ["Units.LENGTH", 0.001, 0],
  "Units.KM_PER_HR": ["Units.VELOCITY", 3.6, 0],
  "Units.KM_PER_SEC": ["Units.VELOCITY", 0.001, 0],
  "Units.KMOL": ["Units.MOLE", 0.001, 0],
  "Units.KMOL_PER_CUB_M": ["Units.MOLAR_CONCENTRATION", 0.001, 0],
  "Units.KMOL_PER_SEC": ["Units.MOLAR_FLOW", 0.001, 0],
  "Units.KN": ["Units.FORCE", 0.001, 0],
  "Units.KN_M": ["Units.TORQUE", 0.001, 0],
  "Units.KN_M_PER_M": ["Units.LINEAR_TORQUE", 0.001, 0],
  "Units.KN_M_PER_RAD": ["Units.ROTATIONAL_SPRING_CONSTANT", 0.001, 0],
  "Units.KN_M_PER_SQ_M": ["Units.AREA_TORQUE", 0.001, 0],
  "Units.KN_PER_CUB_FT": ["Units.FORCE_DENSITY", 0.000028316846592, 0],
  "Units.KN_PER_CUB_M": ["Units.FORCE_DENSITY", 0.001, 0],
  "Units.KN_PER_M": ["Units.LINEAR_LOAD", 0.001, 0],
  "Units.KN_PER_RAD": ["Units.LINEAR_ROTATIONAL_SPRING_CONSTANT", 0.001, 0],
  "Units.KNOT_INTERNATIONAL": ["Units.VELOCITY", 1.9438444924406, 0],
  "Units.KOHM": ["Units.ELECTRICAL_RESISTANCE", 0.001, 0],
  "Units.KPF": ["Units.FORCE", 0.00022480894309971, 0],
  "Units.KPF_FT": ["Units.TORQUE", 0.000737562149277265, 0],
  "Units.KPF_FT_PER_FT": ["Units.LINEAR_TORQUE", 0.00022480894309971, 0],
  "Units.KPF_FT_PER_RAD": ["Units.ROTATIONAL_SPRING_CONSTANT", 0.000737562149277265, 0],
  "Units.KPF_FT_PER_SQ_FT": ["Units.AREA_TORQUE", 0.0000685217658567918, 0],
  "Units.KPF_PER_CUB_FT": ["Units.FORCE_DENSITY", 0.00000636588035426416, 0],
  "Units.KPF_PER_FT": ["Units.LINEAR_LOAD", 0.0000685217658567918, 0],
  "Units.KPF_PER_RAD": ["Units.LINEAR_ROTATIONAL_SPRING_CONSTANT", 0.00022480894309971, 0],
  "Units.KSF": ["Units.PRESSURE", 0.0000208854342331501, 0],
  "Units.KSI": ["Units.PRESSURE", 1.45037737730209e-7, 0],
  "Units.KVA": ["Units.APPARENT_POWER", 0.001, 0],
  "Units.KW": ["Units.POWER", 0.001, 0],
  "Units.KWH": ["Units.WORK", 2.77777777777778e-7, 0],
  "Units.KWH_PER_CUB_FT": ["Units.ENERGY_DENSITY", 7.86579072e-9, 0],
  "Units.KWH_PER_CUB_M": ["Units.ENERGY_DENSITY", 2.77777777777778e-7, 0],
  "Units.KWH_PER_MILLION_GALLON": ["Units.ENERGY_DENSITY", 0.00105150327333333, 0],
  "Units.LB_MOL": ["Units.MOLE", 0.00220462262184878, 0],
  "Units.LBF": ["Units.FORCE", 0.22480894309971, 0],
  "Units.LBF_FT": ["Units.TORQUE", 0.737562149277265, 0],
  "Units.LBF_FT_PER_FT": ["Units.LINEAR_TORQUE", 0.224808943099711, 0],
  "Units.LBF_FT_PER_SQ_FT": ["Units.AREA_TORQUE", 0.0685217658567917, 0],
  "Units.LBF_IN": ["Units.TORQUE", 8.85074579132718, 0],
  "Units.LBF_IN_PER_IN": ["Units.LINEAR_TORQUE", 0.224808943099711, 0],
  "Units.LBF_IN_PER_SQ_IN": ["Units.AREA_TORQUE", 0.00571014715473265, 0],
  "Units.LBF_PER_FT": ["Units.LINEAR_LOAD", 0.0685217658567918, 0],
  "Units.LBF_PER_IN": ["Units.LINEAR_LOAD", 0.00571014715473265, 0],
  "Units.LBF_PER_SQ_FT": ["Units.PRESSURE", 0.0208854342331501, 0],
  "Units.LBM": ["Units.MASS", 2.20462262184878, 0],
  "Units.LBM_PER_ACRE": ["Units.SURFACE_DENSITY", 8921.79121619704, 0],
  "Units.LBM_PER_CUB_FT": ["Units.DENSITY", 0.0624279605761446, 0],
  "Units.LBM_PER_CUB_IN": ["Units.DENSITY", 0.0000361272920000837, 0],
  "Units.LBM_PER_DAY": ["Units.MASS_FLOW", 190479.394527734, 0],
  "Units.LBM_PER_FT": ["Units.LINEAR_DENSITY", 0.671968975139507, 0],
  "Units.LBM_PER_FT_S": ["Units.DYNAMIC_VISCOSITY", 0.671968975139507, 0],
  "Units.LBM_PER_GALLON": ["Units.DENSITY", 0.00834540445201933, 0],
  "Units.LBM_PER_GALLON_IMPERIAL": ["Units.DENSITY", 0.0100224128549605, 0],
  "Units.LBM_PER_HR": ["Units.MASS_FLOW", 7936.64143865559, 0],
  "Units.LBM_PER_MILLION_GALLON": ["Units.DENSITY", 8345.40445201933, 0],
  "Units.LBM_PER_MIN": ["Units.MASS_FLOW", 132.277357310927, 0],
  "Units.LBM_PER_SEC": ["Units.MASS_FLOW", 2.20462262184878, 0],
  "Units.LINEAR_SPRING_CONSTANT_KN_PER_SQ_M": ["Units.LINEAR_SPRING_CONSTANT", 0.001, 0],
  "Units.LINEAR_SPRING_CONSTANT_KPF_PER_SQ_FT": ["Units.LINEAR_SPRING_CONSTANT", 0.0000208854342331501, 0],
  "Units.LINEAR_SPRING_CONSTANT_N_PER_SQ_M": ["Units.LINEAR_SPRING_CONSTANT", 1, 0],
  "Units.LITRE": ["Units.VOLUME", 1000, 0],
  "Units.LITRE_PER_DAY": ["Units.VOLUMETRIC_FLOW", 86400000, 0],
  "Units.LITRE_PER_HR": ["Units.VOLUMETRIC_FLOW", 3600000, 0],
  "Units.LITRE_PER_LITRE": ["Units.VOLUME_RATIO", 1, 0],
  "Units.LITRE_PER_MIN": ["Units.VOLUMETRIC_FLOW", 60000, 0],
  "Units.LITRE_PER_SEC": ["Units.VOLUMETRIC_FLOW", 1000, 0],
  "Units.LITRE_PER_SQ_M_SEC": ["Units.FLOW_DENSITY_PER_AREA", 1000, 0],
  "Units.LONG_TON_FORCE": ["Units.FORCE", 0.000100361135312371, 0],
  "Units.LONG_TON_MASS": ["Units.MASS", 0.000984206527611061, 0],
  "Units.LUMEN": ["Units.LUMINOUS_FLUX", 1, 0],
  "Units.LUMEN_PER_SQ_FT": ["Units.ILLUMINANCE", 0.09290304, 0],
  "Units.LUMEN_PER_W": ["Units.LUMINOUS_EFFICACY", 1, 0],
  "Units.LUX": ["Units.ILLUMINANCE", 1, 0],
  "Units.M": ["Units.LENGTH", 1, 0],
  "Units.M_H2O": ["Units.PRESSURE", 0.000101971621297793, 0],
  "Units.M_HORIZONTAL_PER_M_VERTICAL": ["Units.SLOPE", 1, 0, "Units.M_PER_M"],
  "Units.M_KM": ["Units.PIPE_DIAMETER_LENGTH", 0.001, 0],
  "Units.M_M": ["Units.PIPE_DIAMETER_LENGTH", 1, 0],
  "Units.M_PER_DAy": ["Units.VELOCITY", 86400, 0],
  "Units.M_PER_HR": ["Units.VELOCITY", 3600, 0],
  "Units.M_PER_KM": ["Units.SLOPE", 1000, 0],
  "Units.M_PER_KN": ["Units.FORCE_DISPLAY_SCALE", 1000, 0],
  "Units.M_PER_M": ["Units.SLOPE", 1, 0],
  "Units.M_PER_MIN": ["Units.VELOCITY", 60, 0],
  "Units.M_PER_N": ["Units.FORCE_DISPLAY_SCALE", 1, 0],
  "Units.M_PER_RAD": ["Units.THREAD_PITCH", 1, 0],
  "Units.M_PER_REVOLUTION": ["Units.THREAD_PITCH", 6.28318530717959, 0],
  "Units.M_PER_SEC": ["Units.VELOCITY", 1, 0],
  "Units.M_PER_SEC_SQ": ["Units.ACCELERATION", 1, 0],
  "Units.M_TO_THE_FOURTH": ["Units.AREA_MOMENT_INERTIA", 1, 0],
  "Units.M_TO_THE_SIXTH": ["Units.TORSIONAL_WARPING_CONSTANT", 1, 0],
  "Units.MBAR": ["Units.PRESSURE", 0.01, 0],
  "Units.MEGAGRAM": ["Units.MASS", 0.001, 0],
  "Units.MEGAJ": ["Units.WORK", 0.000001, 0],
  "Units.MEGAJ_PER_KG": ["Units.SPECIFIC_ENERGY", 0.000001, 0],
  "Units.MEGAN": ["Units.FORCE", 0.000001, 0],
  "Units.MEGAN_M": ["Units.TORQUE", 0.000001, 0],
  "Units.MEGAN_M_PER_M": ["Units.LINEAR_TORQUE", 0.000001, 0],
  "Units.MEGAN_M_PER_SQ_M": ["Units.AREA_TORQUE", 0.000001, 0],
  "Units.MEGAN_PER_M": ["Units.LINEAR_LOAD", 0.000001, 0],
  "Units.MEGAPASCAL": ["Units.PRESSURE", 0.000001, 0],
  "Units.MEGAPASCAL_GAUGE": ["Units.PRESSURE", 0.000001, -0.101325],
  "Units.MEGAVOLT": ["Units.ELECTRIC_POTENTIAL", 0.000001, 0],
  "Units.MEGAW": ["Units.POWER", 0.000001, 0],
  "Units.MEGAWH": ["Units.WORK", 2.77777777777778e-10, 0],
  "Units.MG": ["Units.MASS", 1000000, 0],
  "Units.MG_PER_DAY": ["Units.MASS_FLOW", 86400000000, 0],
  "Units.MG_PER_HR": ["Units.MASS_FLOW", 3600000000, 0],
  "Units.MG_PER_LITRE": ["Units.DENSITY", 1000, 0],
  "Units.MG_PER_MIN": ["Units.MASS_FLOW", 60000000, 0],
  "Units.MG_PER_SEC": ["Units.MASS_FLOW", 1000000, 0],
  "Units.MHZ": ["Units.FREQUENCY", 0.000001, 0],
  "Units.MICROAMPERE": ["Units.CURRENT", 1000000, 0],
  "Units.MICROINCH": ["Units.LENGTH", 39370078.7401575, 0],
  "Units.MICROLITRE": ["Units.VOLUME", 1000000000, 0],
  "Units.MICROMOL_PER_CUB_DM": ["Units.MOLAR_CONCENTRATION", 1000, 0],
  "Units.MICROPASCAL": ["Units.PRESSURE", 1000000, 0],
  "Units.MILE": ["Units.LENGTH", 0.000621371192237334, 0],
  "Units.MILLIAMPERE": ["Units.CURRENT", 1000, 0],
  "Units.MILLIFOOT": ["Units.LENGTH", 3280.83989501312, 0],
  "Units.MILLIINCH": ["Units.LENGTH", 39370.0787401575, 0],
  "Units.MILLILITRE": ["Units.VOLUME", 1000000, 0],
  "Units.MILLION_GALLON": ["Units.VOLUME", 0.000264172052358148, 0],
  "Units.MILLION_LITRE": ["Units.VOLUME", 0.001, 0],
  "Units.MIN": ["Units.TIME", 0.0166666666666667, 0],
  "Units.MKG": ["Units.MASS", 1000000000, 0],
  "Units.MKG_PER_DAY": ["Units.MASS_FLOW", 86400000000000, 0],
  "Units.MKG_PER_HR": ["Units.MASS_FLOW", 3600000000000, 0],
  "Units.MKG_PER_LITRE": ["Units.DENSITY", 1000000, 0],
  "Units.MKG_PER_MIN": ["Units.MASS_FLOW", 60000000000, 0],
  "Units.MKG_PER_SEC": ["Units.MASS_FLOW", 1000000000, 0],
  "Units.MKS": ["Units.TIME", 1000000, 0],
  "Units.MM": ["Units.LENGTH", 1000, 0],
  "Units.MM_H2O": ["Units.PRESSURE", 0.101971621297793, 0],
  "Units.MM_HG_AT_32F": ["Units.PRESSURE", 0.00750063755419211, 0],
  "Units.MM_KM": ["Units.PIPE_DIAMETER_LENGTH", 1, 0],
  "Units.MM_M": ["Units.PIPE_DIAMETER_LENGTH", 1000, 0],
  "Units.MM_MILE": ["Units.PIPE_DIAMETER_LENGTH", 0.621371192237334, 0],
  "Units.MM_PER_DAY": ["Units.VELOCITY", 86400000, 0],
  "Units.MM_PER_HR": ["Units.VELOCITY", 3600000, 0],
  "Units.MM_PER_M": ["Units.SLOPE", 1000, 0],
  "Units.MM_PER_MIN": ["Units.VELOCITY", 60000, 0],
  "Units.MM_PER_SEC": ["Units.VELOCITY", 1000, 0],
  "Units.MM_TO_THE_FOURTH": ["Units.AREA_MOMENT_INERTIA", 1000000000000, 0],
  "Units.MM_TO_THE_SIXTH": ["Units.TORSIONAL_WARPING_CONSTANT", 1000000000000000000, 0],
  "Units.MN": ["Units.FORCE", 1000, 0],
  "Units.MOL": ["Units.MOLE", 1, 0],
  "Units.MOL_PER_CUB_DM": ["Units.MOLAR_CONCENTRATION", 0.001, 0],
  "Units.MOL_PER_CUB_FT": ["Units.MOLAR_CONCENTRATION", 0.028316846592, 0],
  "Units.MOL_PER_CUB_M": ["Units.MOLAR_CONCENTRATION", 1, 0],
  "Units.MOL_PER_SEC": ["Units.MOLAR_FLOW", 1, 0],
  "Units.MONETARY_UNIT": ["Units.CURRENCY", 1, 0],
  "Units.MPH": ["Units.VELOCITY", 2.2369362920544, 0],
  "Units.MS": ["Units.TIME", 1000, 0],
  "Units.MVA": ["Units.APPARENT_POWER", 0.000001, 0],
  "Units.N": ["Units.FORCE", 1, 0],
  "Units.N_CM": ["Units.TORQUE", 100, 0],
  "Units.N_CM_PER_CM": ["Units.LINEAR_TORQUE", 1, 0],
  "Units.N_CM_PER_SQ_CM": ["Units.AREA_TORQUE", 0.01, 0],
  "Units.N_M": ["Units.TORQUE", 1, 0],
  "Units.N_M_PER_DEG": ["Units.ROTATIONAL_SPRING_CONSTANT", 0.0174532925199433, 0],
  "Units.N_M_PER_M": ["Units.LINEAR_TORQUE", 1, 0],
  "Units.N_M_PER_RAD": ["Units.ROTATIONAL_SPRING_CONSTANT", 1, 0],
  "Units.N_M_PER_SQ_M": ["Units.AREA_TORQUE", 1, 0],
  "Units.N_PER_CUB_FT": ["Units.FORCE_DENSITY", 0.028316846592, 0],
  "Units.N_PER_CUB_M": ["Units.FORCE_DENSITY", 1, 0],
  "Units.N_PER_M": ["Units.LINEAR_LOAD", 1, 0],
  "Units.N_PER_MM": ["Units.LINEAR_LOAD", 0.001, 0],
  "Units.N_PER_RAD": ["Units.LINEAR_ROTATIONAL_SPRING_CONSTANT", 1, 0],
  "Units.NAUT_MILE": ["Units.LENGTH", 0.000539956803455724, 0],
  "Units.NG": ["Units.MASS", 1000000000000, 0],
  "Units.NMOL_PER_CUB_DM": ["Units.MOLAR_CONCENTRATION", 1000000, 0],
  "Units.OHM": ["Units.ELECTRICAL_RESISTANCE", 1, 0],
  "Units.OHM_M": ["Units.ELECTRICAL_RESISTIVITY", 1, 0],
  "Units.ONE": ["Units.NUMBER", 1, 0],
  "Units.OZF": ["Units.FORCE", 3.59694308959537, 0],
  "Units.OZM": ["Units.MASS", 35.2739619495804, 0],
  "Units.PA": ["Units.PRESSURE", 1, 0],
  "Units.PA_GAUGE": ["Units.PRESSURE", 1, -101325],
  "Units.PA_PER_M": ["Units.PRESSURE_GRADIENT", 1, 0],
  "Units.PA_S": ["Units.DYNAMIC_VISCOSITY", 1, 0],
  "Units.PDL": ["Units.FORCE", 7.23301385120989, 0],
  "Units.PER_FT": ["Units.LINEAR_RATE", 0.3048, 0],
  "Units.PER_KM": ["Units.LINEAR_RATE", 1000, 0],
  "Units.PER_M": ["Units.LINEAR_RATE", 1, 0],
  "Units.PER_MILE": ["Units.LINEAR_RATE", 1609.344, 0],
  "Units.PER_MM": ["Units.LINEAR_RATE", 0.001, 0],
  "Units.PER_THOUSAND_FT": ["Units.LINEAR_RATE", 304.8, 0],
  "Units.PERCENT": ["Units.PERCENTAGE", 1, 0],
  "Units.PERCENT_SLOPE": ["Units.SLOPE", 100, 0],
  "Units.PERSON": ["Units.CAPITA", 1, 0],
  "Units.PERSON_PER_ACRE": ["Units.POPULATION_DENSITY", 4046.8564224, 0],
  "Units.PERSON_PER_HECTARE": ["Units.POPULATION_DENSITY", 10000, 0],
  "Units.PERSON_PER_SQ_FT": ["Units.POPULATION_DENSITY", 0.09290304, 0],
  "Units.PERSON_PER_SQ_KM": ["Units.POPULATION_DENSITY", 1000000, 0],
  "Units.PERSON_PER_SQ_M": ["Units.POPULATION_DENSITY", 1, 0],
  "Units.PERSON_PER_SQ_MILE": ["Units.POPULATION_DENSITY", 2589988.110336, 0],
  "Units.PICOMOL_PER_CUB_DM": ["Units.MOLAR_CONCENTRATION", 1000000000, 0],
  "Units.POISE": ["Units.DYNAMIC_VISCOSITY", 10, 0],
  "Units.PROBABILITY_FRACTION": ["Units.PROBABILITY", 1, 0],
  "Units.PROBABILITY_PERCENT": ["Units.PROBABILITY", 100, 0],
  "Units.PSF": ["Units.PRESSURE", 0.0208854342331501, 0],
  "Units.PSI": ["Units.PRESSURE", 0.000145037737730209, 0],
  "Units.PSIG": ["Units.PRESSURE", 0.000145037737730209, -14.6959487755134],
  "Units.RAD": ["Units.ANGLE", 1, 0],
  "Units.RAD_PER_HR": ["Units.ANGULAR_VELOCITY", 3600, 0],
  "Units.RAD_PER_MIN": ["Units.ANGULAR_VELOCITY", 60, 0],
  "Units.RAD_PER_SEC": ["Units.ANGULAR_VELOCITY", 1, 0],
  "Units.RANKINE": ["Units.TEMPERATURE", 1.8, 0],
  "Units.REVOLUTION": ["Units.ANGLE", 0.159154943091895, 0],
  "Units.RPH": ["Units.ANGULAR_VELOCITY", 572.957795130823, 0],
  "Units.RPM": ["Units.ANGULAR_VELOCITY", 9.54929658551372, 0],
  "Units.RPS": ["Units.ANGULAR_VELOCITY", 0.159154943091895, 0],
  "Units.S": ["Units.TIME", 1, 0],
  "Units.SHORT_TON_FORCE": ["Units.FORCE", 0.000112404471549855, 0],
  "Units.SHORT_TON_MASS": ["Units.MASS", 0.00110231131092439, 0],
  "Units.SHORT_TON_PER_CUB_FT": ["Units.DENSITY", 0.0000312139802880723, 0],
  "Units.SHORT_TON_PER_HR": ["Units.MASS_FLOW", 3.9683207193278, 0],
  "Units.SLUG": ["Units.MASS", 0.0685217658567918, 0],
  "Units.SLUG_PER_CUB_FT": ["Units.DENSITY", 0.00194032033197972, 0],
  "Units.SPRING_CONSTANT_KN_PER_M": ["Units.SPRING_CONSTANT", 0.001, 0],
  "Units.SPRING_CONSTANT_KPF_PER_FT": ["Units.SPRING_CONSTANT", 0.0000685217658567918, 0],
  "Units.SPRING_CONSTANT_N_PER_M": ["Units.SPRING_CONSTANT", 1, 0],
  "Units.SQ_CHAIN": ["Units.AREA", 0.00247105381467165, 0],
  "Units.SQ_CM": ["Units.AREA", 10000, 0],
  "Units.SQ_DM": ["Units.AREA", 100, 0],
  "Units.SQ_FT": ["Units.AREA", 10.7639104167097, 0],
  "Units.SQ_FT_HR_FAHRENHEIT_PER_BTU": ["Units.THERMAL_INSULANCE", 5.67826334111349, 0],
  "Units.SQ_FT_PER_SEC": ["Units.KINEMATIC_VISCOSITY", 10.7639104167097, 0],
  "Units.SQ_IN": ["Units.AREA", 1550.0031000062, 0],
  "Units.SQ_KM": ["Units.AREA", 0.000001, 0],
  "Units.SQ_M": ["Units.AREA", 1, 0],
  "Units.SQ_M_CELSIUS_PER_WATT": ["Units.THERMAL_INSULANCE", 1, 0],
  "Units.SQ_M_KELVIN_PER_WATT": ["Units.THERMAL_INSULANCE", 1, 0],
  "Units.SQ_M_PER_SEC": ["Units.KINEMATIC_VISCOSITY", 1, 0],
  "Units.SQ_MILE": ["Units.AREA", 3.86102158542446e-7, 0],
  "Units.SQ_MM": ["Units.AREA", 1000000, 0],
  "Units.SQ_UM": ["Units.AREA", 1000000000000, 0],
  "Units.SQ_US_SURVEY_CHAIN": ["Units.AREA", 0.00247104393046628, 0],
  "Units.SQ_US_SURVEY_FT": ["Units.AREA", 10.7638673611111, 0],
  "Units.SQ_US_SURVEY_IN": ["Units.AREA", 1549.9969, 0],
  "Units.SQ_US_SURVEY_MILE": ["Units.AREA", 3.86100614135356e-7, 0],
  "Units.SQ_US_SURVEY_YRD": ["Units.AREA", 1.19598526234568, 0],
  "Units.SQ_YRD": ["Units.AREA", 1.19599004630108, 0],
  "Units.STERAD": ["Units.SOLIDANGLE", 1, 0],
  "Units.STOKE": ["Units.KINEMATIC_VISCOSITY", 10000, 0],
  "Units.STRAIN_PER_CELSIUS": ["Units.LINEAR_COEFFICIENT_OF_THERMAL_EXPANSION", 1, 0],
  "Units.STRAIN_PER_FAHRENHEIT": ["Units.LINEAR_COEFFICIENT_OF_THERMAL_EXPANSION", 0.555555555555556, 0],
  "Units.STRAIN_PER_KELVIN": ["Units.LINEAR_COEFFICIENT_OF_THERMAL_EXPANSION", 1, 0],
  "Units.STRAIN_PER_RANKINE": ["Units.LINEAR_COEFFICIENT_OF_THERMAL_EXPANSION", 0.555555555555556, 0],
  "Units.THOUSAND_GALLON": ["Units.VOLUME", 0.264172052358148, 0],
  "Units.THOUSAND_LITRE": ["Units.VOLUME", 1, 0],
  "Units.THOUSAND_PERSON": ["Units.CAPITA", 0.001, 0],
  "Units.THOUSAND_SQ_FT": ["Units.AREA", 0.0107639104167097, 0],
  "Units.TONNE": ["Units.MASS", 0.001, 0],
  "Units.TONNE_PER_HR": ["Units.MASS_FLOW", 3.6, 0],
  "Units.TORR": ["Units.PRESSURE", 0.0075006168270417, 0],
  "Units.UM": ["Units.LENGTH", 1000000, 0],
  "Units.US_DOLLAR": ["Units.CURRENCY", 1, 0],
  "Units.US_SURVEY_ACRE": ["Units.AREA", 0.000247104393046628, 0],
  "Units.US_SURVEY_CHAIN": ["Units.LENGTH", 0.049709595959596, 0],
  "Units.US_SURVEY_FT": ["Units.LENGTH", 3.28083333333333, 0],
  "Units.US_SURVEY_IN": ["Units.LENGTH", 39.37, 0],
  "Units.US_SURVEY_MILE": ["Units.LENGTH", 0.000621369949494949, 0],
  "Units.US_SURVEY_YRD": ["Units.LENGTH", 1.09361111111111, 0],
  "Units.VA": ["Units.APPARENT_POWER", 1, 0],
  "Units.VERTICAL_PER_HORIZONTAL": ["Units.SLOPE", 1, 0],
  "Units.VOLT": ["Units.ELECTRIC_POTENTIAL", 1, 0],
  "Units.W": ["Units.POWER", 1, 0],
  "Units.W_PER_M_C": ["Units.THERMAL_CONDUCTIVITY", 1, 0],
  "Units.W_PER_M_K": ["Units.THERMAL_CONDUCTIVITY", 1, 0],
  "Units.W_PER_SQ_M": ["Units.HEAT_FLUX_DENSITY", 1, 0],
  "Units.W_PER_SQ_M_CELSIUS": ["Units.HEAT_TRANSFER", 1, 0],
  "Units.W_PER_SQ_M_K": ["Units.HEAT_TRANSFER", 1, 0],
  "Units.WATT_SECOND": ["Units.WORK", 1, 0],
  "Units.WEEK": ["Units.TIME", 0.00000165343915343915, 0],
  "Units.YEAR_SIDEREAL": ["Units.TIME", 3.16875355494539e-8, 0],
  "Units.YEAR_TROPICAL": ["Units.TIME", 3.16887605987021e-8, 0],
  "Units.YR": ["Units.TIME", 3.17097919837646e-8, 0],
  "Units.YRD": ["Units.LENGTH", 1.09361329833771, 0],
  "Units.YRD_PER_SEC": ["Units.VELOCITY", 1.09361329833771, 0],
} as const;
